var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-form', [_c('el-upload', {
    ref: "upload",
    attrs: {
      "accept": ".csv",
      "file-list": _vm.fileList,
      "action": _vm.action,
      "list-type": "text",
      "headers": _vm.headers,
      "data": _vm.data,
      "on-success": _vm.onUploadSuccess,
      "on-error": _vm.onUploadError
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Upload CSV")]), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(" A CSV file with at least 2 columns: Email and Feature ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }